import React from "react";

export const WindyIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="24" fillRule="nonzero" fill="#3F4447">
                <g transform="translate(4.000000, 15.000000)">
                    <path
                        d="M43.248 23.296a6.197 6.197 0 116.198 6.197H21.042a1.55 1.55 0 000 3.098h28.404a9.296 9.296 0 10-9.296-9.295 1.55 1.55 0 003.099 0zM40.15 55.315a9.296 9.296 0 009.296 9.295 9.296 9.296 0 100-18.591H5.549a1.55 1.55 0 100 3.098h43.897a6.197 6.197 0 11-6.198 6.198 1.55 1.55 0 10-3.098 0z"
                        fill="#717277"
                    />
                    <path
                        d="M68.037 25.361a6.197 6.197 0 110 12.395H5.55a1.55 1.55 0 000 3.098h62.488a9.296 9.296 0 009.296-9.295 9.296 9.296 0 00-9.296-9.296 1.55 1.55 0 100 3.098z"
                        fill="#717277"
                    />
                </g>
            </g>
        </g>
    </svg>
);
